import type { FieldValues, Path, UseFormSetError } from 'react-hook-form';
import { ApiError } from './api';

/**
 * API の 400/409 エラー（details: [{ path, message }]）を react-hook-form のフィールドエラーへ反映する。
 * 反映できたフィールドがあれば true を返す（その場合トーストは不要なことが多い）。
 *
 * @example
 *   catch (e) { if (!applyApiErrors(e, setError)) toast.error('保存できませんでした', errorMessage(e)); }
 */
export function applyApiErrors<T extends FieldValues>(error: unknown, setError: UseFormSetError<T>): boolean {
  if (!(error instanceof ApiError)) return false;
  const entries = Object.entries(error.fieldErrors);
  entries.forEach(([path, message], i) => {
    setError(path as Path<T>, { type: 'server', message }, { shouldFocus: i === 0 });
  });
  return entries.length > 0;
}
